import type { FC } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface AppLocationObserverProps {
  readonly onLocationChange: (pathname: string) => void;
}

const AppLocationObserver: FC<AppLocationObserverProps> = ({ onLocationChange }) => {
  'use memo';

  const { pathname } = useLocation();

  useEffect(() => {
    onLocationChange(pathname);
  }, [onLocationChange, pathname]);

  return null;
};

export default AppLocationObserver;
